import React from 'react'
import { createFileRoute, Outlet } from '@tanstack/react-router'
import { AdminRouteGuard } from '../components'
import { NotFoundPage } from '@/components/infoPages/NotFoundPage'

export const Route = createFileRoute('/admin')({
  component: () => (
    <AdminRouteGuard>
      <Outlet />
    </AdminRouteGuard>
  ),
  notFoundComponent: NotFoundPage,
})
